var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-link',{staticClass:"back",on:{"click":function($event){return _vm.$f7router.back()}}},[_c('f7-icon',{attrs:{"f7":"chevron_left","color":"white"}})],1),_c('WeatherForecast')],1)}
var staticRenderFns = []

export { render, staticRenderFns }